import React from 'react';
import { Container } from 'react-bootstrap';

/** Círculo de carga inline (sin texto). */
export function LoadingCircle({ size = 'md', className = '' }) {
  const sizeClass = size === 'sm' ? 'spinner-border-sm' : size === 'lg' ? '' : '';
  return (
    <span
      className={`spinner-border text-primary ${sizeClass} ${className}`.trim()}
      role="status"
      aria-label="Espere"
    />
  );
}

/** Muestra número o círculo de carga mientras `loading` es true (evita flash de 0). */
export function LoadingValue({ loading, children, size = 'sm' }) {
  if (loading) return <LoadingCircle size={size} />;
  return children;
}

const LoadingSpinner = ({ containerClass = '', minHeight = '400px', size = 'md' }) => (
  <div className={`ui-soft-enter ${containerClass}`.trim()}>
    <Container className="py-4">
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight }}
      >
        <LoadingCircle size={size} />
      </div>
    </Container>
  </div>
);

export default LoadingSpinner;
